import { Component, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';


// Die importierten Services
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { LoadingService } from 'src/app/modules/shared/services/loading.service';


@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})

export class LogoutComponent implements AfterViewInit {

  constructor(
    public router: Router, public authService: AuthService, private toast: ToastrService, private http: HttpService, private loading: LoadingService
  ) {
    this.loading.setLoadingState(true);
  }

  ngAfterViewInit() {
    this.http.get('/api/logout', this.doLogout);
  }

  /**
   * Funktion wird bei erfolgreichem ausloggen eines Benutzers durchgeführt.
   * Leert den Localstorage und leitet auf die LoginSeite weiter
   */
  public doLogout = (response: any) => {
    if (response.status === 0) {
      this.authService.setJwtToken(null);
      this.authService.setLoginState(false);
      this.loading.setLoadingState(false);
    } else {
      this.toast.error(response.message, 'Fehler');
    }
  }

}
